import { createSagaAction } from '../../shared/sagas'
import { createReducer } from '../../shared/reducers'

// Constants
export const constants = {
  EMPLOYEES_REFRESH: createSagaAction('EMPLOYEES_REFRESH'),
  CREATE_EMPLOYEE: createSagaAction('CREATE_EMPLOYEE'),
  EDIT_EMPLOYEE: createSagaAction('EDIT_EMPLOYEE'),
  DELETE_EMPLOYEE: createSagaAction('DELETE_EMPLOYEE'),
  EDIT_EMPLOYEE_STATUS: createSagaAction('EDIT_EMPLOYEE_STATUS'),
  UPLOAD_EMPLOYEE_ATTACHMENT: createSagaAction('UPLOAD_EMPLOYEE_ATTACHMENT'),
  GET_EMPLOYEE_ATTACHMENTS: createSagaAction('GET_EMPLOYEE_ATTACHMENTS'),
  UPDATE_EMPLOYEE_ATTACHMENT_DESCRIPTION: createSagaAction(
    'UPDATE_EMPLOYEE_ATTACHMENT_DESCRIPTION'
  ),
  DELETE_EMPLOYEE_ATTACHMENT: createSagaAction('DELETE_EMPLOYEE_ATTACHMENT'),
  // notes
  GET_EMPLOYEE_NOTE: createSagaAction('GET_EMPLOYEE_NOTE'),
  CREATE_EMPLOYEE_NOTE: createSagaAction('CREATE_EMPLOYEE_NOTE'),
  EDIT_EMPLOYEE_NOTE: createSagaAction('EDIT_EMPLOYEE_NOTE'),
  DELETE_EMPLOYEE_NOTE: createSagaAction('DELETE_EMPLOYEE_NOTE'),
  // follow ups
  GET_EMPLOYEE_FOLLOW_UP: createSagaAction('GET_EMPLOYEE_FOLLOW_UP'),
  CREATE_EMPLOYEE_FOLLOW_UP: createSagaAction('CREATE_EMPLOYEE_FOLLOW_UP'),
  EDIT_EMPLOYEE_FOLLOW_UP: createSagaAction('EDIT_EMPLOYEE_FOLLOW_UP'),
  DELETE_EMPLOYEE_FOLLOW_UP: createSagaAction('DELETE_EMPLOYEE_FOLLOW_UP')
}

// Action Creators
export const actions = {
  employeesRefresh: () => ({ type: constants.EMPLOYEES_REFRESH.ACTION }),
  createEmployee: ({ content, userId }) => ({
    type: constants.CREATE_EMPLOYEE.ACTION,
    content,
    userId
  }),
  editEmployee: ({ content, employeeId }) => ({
    type: constants.EDIT_EMPLOYEE.ACTION,
    content,
    employeeId
  }),
  deleteEmployee: ({ employeeId }) => ({
    type: constants.DELETE_EMPLOYEE.ACTION,
    employeeId
  }),
  setStatus: ({ content, employeeId }) => ({
    type: constants.EDIT_EMPLOYEE_STATUS.ACTION,
    content,
    employeeId
  }),
  // Attachment actions
  uploadAttachment: ({ formData, employeeId }) => ({
    type: constants.UPLOAD_EMPLOYEE_ATTACHMENT.ACTION,
    formData,
    employeeId
  }),

  getAttachments: ({ employeeId }) => ({
    type: constants.GET_EMPLOYEE_ATTACHMENTS.ACTION,
    employeeId
  }),

  updateAttachmentDescription: ({ attachmentId, employeeId, description, userId }) => ({
    type: constants.UPDATE_EMPLOYEE_ATTACHMENT_DESCRIPTION.ACTION,
    attachmentId,
    employeeId,
    description,
    userId
  }),

  deleteAttachment: ({ attachmentId, employeeId }) => ({
    type: constants.DELETE_EMPLOYEE_ATTACHMENT.ACTION,
    attachmentId,
    employeeId
  }),
  // notes
  getEmployeeNote: ({ employeeId }) => ({
    type: constants.GET_EMPLOYEE_NOTE.ACTION,
    employeeId
  }),
  createEmployeeNote: ({ content, userId, employeeId }) => ({
    type: constants.CREATE_EMPLOYEE_NOTE.ACTION,
    content,
    userId,
    employeeId
  }),
  editEmployeeNote: ({ content, noteId, employeeId }) => ({
    type: constants.EDIT_EMPLOYEE_NOTE.ACTION,
    content,
    noteId,
    employeeId
  }),
  deleteEmployeeNote: ({ noteId, employeeId }) => ({
    type: constants.DELETE_EMPLOYEE_NOTE.ACTION,
    noteId,
    employeeId
  }),
  // followUps
  getEmployeeFollowUp: ({ employeeId }) => ({
    type: constants.GET_EMPLOYEE_FOLLOW_UP.ACTION,
    employeeId
  }),
  createEmployeeFollowUp: ({ content, userId, employeeId }) => ({
    type: constants.CREATE_EMPLOYEE_FOLLOW_UP.ACTION,
    content,
    userId,
    employeeId
  }),
  editEmployeeFollowUp: ({ content, followUpId, employeeId }) => ({
    type: constants.EDIT_EMPLOYEE_FOLLOW_UP.ACTION,
    content,
    followUpId,
    employeeId
  }),
  deleteEmployeeFollowUp: ({ followUpId, employeeId }) => ({
    type: constants.DELETE_EMPLOYEE_FOLLOW_UP.ACTION,
    followUpId,
    employeeId
  })
}

// Reducer
const initialState = [
  {
    name: ''
  }
]

export default createReducer(initialState, (state, { type, payload }) => {
  switch (type) {
    default:
      return state
    case constants.EMPLOYEES_REFRESH.SUCCESS:
      return { ...state, payload }
    case constants.CREATE_EMPLOYEE.ACTION:
      return { ...state, loading: true }
    case constants.CREATE_EMPLOYEE.SUCCESS:
      return {
        ...state,
        loading: false,
        msg: 'Employee created!'
      }
    case constants.CREATE_EMPLOYEE.FAILED:
      return {
        ...state,
        loading: false,
        msg: 'Problems creating employee, please try again.'
      }
    case constants.EDIT_EMPLOYEE.SUCCESS:
      return {
        ...state,
        loading: false,
        msg: 'Employee edited!'
      }
    case constants.EDIT_EMPLOYEE.FAILED:
      return {
        ...state,
        loading: false,
        msg: 'Problems editing employee, please try again.'
      }
    case constants.DELETE_EMPLOYEE.SUCCESS:
      return {
        ...state,
        loading: false,
        msg: 'Employee deleted!'
      }
    case constants.DELETE_EMPLOYEE.FAILED:
      return {
        ...state,
        loading: false,
        msg: 'Problems deleting employee, please try again.'
      }
    case constants.EDIT_EMPLOYEE_STATUS.ACTION:
      return { ...state, loading: true }
    case constants.EDIT_EMPLOYEE_STATUS.SUCCESS:
      return {
        ...state,
        loading: false,
        msg: 'Vehicle created!'
      }
    case constants.EDIT_EMPLOYEE_STATUS.FAILED:
      return {
        ...state,
        loading: false,
        msg: 'Problems creating vehicle, please try again.'
      }
    case constants.UPLOAD_EMPLOYEE_ATTACHMENT.ACTION:
      return { ...state, error: null, uploadingAttachment: true }
    case constants.UPLOAD_EMPLOYEE_ATTACHMENT.SUCCESS:
      return {
        ...state,
        uploadingAttachment: false
      }

    case constants.GET_EMPLOYEE_ATTACHMENTS.ACTION:
      return { ...state, error: null, loadingAttachments: true }
    case constants.GET_EMPLOYEE_ATTACHMENTS.SUCCESS:
      return {
        ...state,
        employeeAttachments: payload,
        loadingAttachments: false
      }

    case constants.UPDATE_EMPLOYEE_ATTACHMENT_DESCRIPTION.SUCCESS:
      return {
        ...state
      }

    case constants.DELETE_EMPLOYEE_ATTACHMENT.ACTION:
      return { ...state, error: null, deletingAttachment: true }
    case constants.DELETE_EMPLOYEE_ATTACHMENT.SUCCESS:
      return {
        ...state,
        deletingAttachment: false
      }
    // NOTES
    case constants.GET_EMPLOYEE_NOTE.SUCCESS:
      return { ...state, employeesNotes: payload }

    case constants.CREATE_EMPLOYEE_NOTE.ACTION:
      return { ...state }
    case constants.CREATE_EMPLOYEE_NOTE.SUCCESS:
      return {
        ...state
      }
    case constants.EDIT_EMPLOYEE_NOTE.ACTION:
      return { ...state }
    case constants.EDIT_EMPLOYEE_NOTE.SUCCESS:
      return {
        ...state
      }
    case constants.DELETE_EMPLOYEE_NOTE.ACTION:
      return { ...state }
    case constants.DELETE_EMPLOYEE_NOTE.SUCCESS:
      return {
        ...state
      }
    // FOLLOW UPS
    case constants.GET_EMPLOYEE_FOLLOW_UP.SUCCESS:
      return { ...state, employeesFollowUps: payload }

    case constants.CREATE_EMPLOYEE_FOLLOW_UP.ACTION:
      return { ...state }
    case constants.CREATE_EMPLOYEE_FOLLOW_UP.SUCCESS:
      return {
        ...state
      }
    case constants.EDIT_EMPLOYEE_FOLLOW_UP.ACTION:
      return { ...state }
    case constants.EDIT_EMPLOYEE_FOLLOW_UP.SUCCESS:
      return {
        ...state
      }
    case constants.DELETE_EMPLOYEE_FOLLOW_UP.ACTION:
      return { ...state }
    case constants.DELETE_EMPLOYEE_FOLLOW_UP.SUCCESS:
      return {
        ...state
      }
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/employeesActions.js